import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import {Button, Input, Pattern, Toast} from 'gd-react';
import GridDuck from 'gridduck';
import './DesktopLogin.scss';
import 'css-doodle'
import animatedLogo from '../images/animated-logo-once.svg'
import cookie from 'react-cookies'
import GenericLoader from "../components/GenericLoader";
import history from "../meta/history";
import PasswordChecker from "../components/PasswordChecker/PasswordChecker";
import {Icon} from "@material-ui/core";
import ConfirmInvite from "./ConfirmInvite";

class DesktopConfirmInvite extends ConfirmInvite {

	render() {
		this.checkErrors();
		if (this.state.loggedIn === true) {
			return (<Redirect to='/siteGroup/all'/>)
		}
		let logo = require('../images/' + window._loginLogo);
		if (logo && logo.default) {
			logo = logo.default;
		}
		let overrideCompanyName, overridePlatformName;
		if (window.location.hostname.indexOf('inspired.gridduck') !== -1) {
			overrideCompanyName = 'Telemetry App';
			overridePlatformName = 'Unify';
		}
		return (
			<div className={'loginPage'}>
				<Link to="/" style={{
					'position': 'absolute',
					padding: '20px 30px',
					fontSize: '13px',
					color: 'grey',
					textDecoration: 'none'
				}}><Icon/>Back to login</Link>
				{this.state.loaded && !this.state.status ? <div style={{
					'display': 'flex',
					'flexDirection': 'column',
					'flex': 50,
					'justifyContent': 'start',
					'alignItems': 'center',
					overflow: 'auto',
					paddingTop: '100px'
				}}>

					<p className={'subHeader'} style={{marginBottom: '0'}}>Join {overrideCompanyName || this.state.organisationName}</p>
					<p className={'header'} style={{marginBottom: '30px'}}>on {overridePlatformName || window._companyName}</p>
					<form onSubmit={this.handleSubmit}>
						<Input label={'Name'} required type="text"
							   error={this.state.triedToSave && this.errors['name']}
							   name={'name'}
							   onChange={this.onFormChange}
							   value={this.state.invite.name}/>
						<Input label={'Job Role'} required type="text"
							   error={this.state.triedToSave && this.errors['jobRole']}
							   name={'jobRole'}
							   onChange={this.onFormChange}
							   value={this.state.invite.jobRole}/>
						<Input label={'Email'} disabled type="text"
							   value={this.state.emailAddress}/>
						<PasswordChecker label={'Password'} onChange={this.pwChanged}/>
						<br/>
						<div style={{'display': 'flex', 'flexDirection': 'row-reverse', justifyContent: 'center'}}>
							<Button
								additionalclasses={'sm'}
								label="Complete Signup"
								progressRes
								onClick={this.handleSubmit}
							/>
						</div>
						<br/>
					</form>
					<br/>
					<div>{this.state.loginError}</div>
				</div> : ''}
				{!this.state.loaded ? <div style={{
					'display': 'flex',
					'flexDirection': 'column',
					'flex': 50,
					'justifyContent': 'center',
					'alignItems': 'center'
				}}><GenericLoader  text={"Fetching"} textLineTwo={"Invite Details..."}/></div> : ''}
				{this.state.loaded && this.state.status ? <div style={{
					'display': 'flex',
					'flexDirection': 'column',
					'flex': 50,
					'justifyContent': 'center',
					'alignItems': 'center',
					overflow: 'auto'
				}}><p className={'subHeader'} style={{marginBottom: '0'}}>Whoops!</p>
					<p className={'header'} style={{marginBottom: '30px'}}>{this.state.status}</p></div> : ''}
				<div style={{
					'display': 'flex',
					'flexDirection': 'column',
					'overflow': 'hidden',
					'flex': 50,
					justifyContent: 'center',
					alignItems: 'center',
					'backgroundColor': window._loginBgCol
				}}>
					<img alt={'img'} src={logo} className={'animated-logo'}/>
					<css-doodle grid='20'>
						{':doodle { grid-gap: 5px; width: 50vw; height: 100vh; position: relative; } border-radius: 100%; border: 0px solid rgb(44 71 82); background: ' + window._loginDotsCol + '; --scaledelay: calc(( (@abs(@abs(@row - @size-row/3) + @abs(@col - @size-col/4) - @size-col) / @size-col) - 1) * -4s) ; animation-name: scale; animation-duration: 5s; animation-iteration-count: infinite; animation-timing-function: ease; animation-delay: var(--scaledelay); transform: scale(0.2); opacity: 0.2; @keyframes scale { 0%{ transform: scale(0.2); opacity: 0.2; } 50%{ transform: scale(0.8); opacity: 0.7; } 100%{ transform: scale(0.2); opacity: 0.1 } }'}
					</css-doodle>
				</div>
			</div>
		);
	}
}

export default DesktopConfirmInvite;
